/**
 * 공용 에러 메시지 추출 — FastAPI 응답 3형태 파싱
 * ① detail: 문자열 ② 검증 실패 detail: [{loc, msg}] 배열 ③ ApiError 래핑(message만)
 * 모달류 공용. 기존 StockTxModal/FundTxModal/MmAssetModal 로컬 구현과 동일 로직.
 */
export const extractErrMsg = (e: any): string => {
  const d = e?.response?.data ?? e?.payload ?? null;
  if (typeof d?.detail === "string") return d.detail;
  if (Array.isArray(d?.detail)) {
    return d.detail
      .map((x: any) => `${(x.loc || []).slice(-1)[0] ?? ""}: ${x.msg ?? ""}`)
      .join(", ");
  }
  return e?.message || "알 수 없는 오류";
};
